import { getDateText } from "@/js/time/format";

export const USER_DATA_TABLE_TYPE = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  INVITED: "invited",
};

export function getBaseDataForUserDataTable({ user, dataTableType }) {
  return {
    status: getStatusInfo({
      user,
      dataTableType,
    }),
    lastInteractionString: getLastInteractionInfo({ user }),
  };
}

function getStatusInfo({ user, dataTableType }) {
  switch (dataTableType) {
    case USER_DATA_TABLE_TYPE.INVITED:
      if (user.status.toLowerCase().includes("error")) {
        return "could-not-be-invited";
      } else if (user.status == "expired") {
        return "invitation-expired";
      } else {
        return "invited";
      }
    default:
      return user.disabled === true ? "inactive" : "active";
  }
}

function getLastInteractionInfo({ user }) {
  const lastInteraction = user.lastInteraction;

  // handle data for China.
  if (typeof lastInteraction === "number") {
    return getDateText(lastInteraction * 1000);
  }

  // handle data for Global.
  if (typeof lastInteraction?.seconds === "number") {
    return getDateText(lastInteraction.seconds * 1000);
  }

  return "-";
}
